import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { STATE_STATUS } from '@awp/constants';

export const fetchCameraViews = createAsyncThunk(
  'cameraViews/fetchCameraViews',
  async (weatherStationId, { getState }) => {
    const url = `/api/v1/weatherstations/${weatherStationId}/cameras`;
    const res = await fetch(url, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
    const cameras = await res.json();

    return cameras.sort((a, b) => {
      switch (true) {
        case a.Name > b.Name:
          return 1;
        case a.Name < b.Name:
          return -1;
        default:
          return 0;
      }
    });
  },
  {
    condition: (weatherStationId, { getState }) => {
      const state = getState();
      if (!weatherStationId || weatherStationId < 1) return false;
      if (isCameraLoading(state) || hasCameraLoaded(state)) return false;

      return true;
    },
  },
);

const initialState = {
  status: STATE_STATUS.IDLE,
  error: null,
  data: [],
};

export const getCameraViews = (state) => state.cameraViews.data;
export const getCameraViewsLoadingStatus = (state) => state.cameraViews.status;
export const isCameraLoading = (state) => state.cameraViews.status === STATE_STATUS.LOADING;
export const hasCameraLoaded = (state) =>
  state.cameraViews.status === STATE_STATUS.SUCCESS || state.cameraViews.status === STATE_STATUS.FAILED;

export const cameraViewsSlice = createSlice({
  name: 'cameraViews',
  initialState,
  reducers: {
    setCameraStatus(state, action) {
      return { ...state, status: action.payload };
    },
  },
  extraReducers: {
    [fetchCameraViews.pending.toString()]: (state) => {
      state.status = STATE_STATUS.LOADING;
    },
    [fetchCameraViews.fulfilled.toString()]: (state, { payload }) => {
      state.status = STATE_STATUS.SUCCESS;
      state.data = payload;
    },
    [fetchCameraViews.rejected.toString()]: (state) => {
      state.status = STATE_STATUS.FAILED;
    },
  },
});
export const { setCameraStatus } = cameraViewsSlice.actions;
